<template>
  <base-modal v-model="localValue" :title="title" hideClose>
    <login-form :loginCallback="loginCallback"/>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal'
import LoginForm from '@/components/forms/LoginForm'
import wrapperMixin from '@/mixins/wrapper.mixin'

export default {
  components: {
    BaseModal,
    LoginForm
  },
  props: {
    title: String,
    loginCallback: Function,
    returnUrl: String
  },
  mixins: [
    wrapperMixin(Boolean)
  ],
  data () {
    return {
      signInVisible: false
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/base/modals/LoginFormModal.vue